/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconClose from '@telus-uds/palette-allium/build/rn/icons/Close'
import PaletteIconStatusInfo from '@telus-uds/palette-allium/build/rn/icons/StatusInfo'
import PaletteIconStatusSuccess from '@telus-uds/palette-allium/build/rn/icons/StatusSuccess'
import PaletteIconStatusWarning from '@telus-uds/palette-allium/build/rn/icons/StatusWarning'
import PaletteIconStatusError from '@telus-uds/palette-allium/build/rn/icons/StatusError'
import PaletteIconTagFilled from '@telus-uds/palette-allium/build/rn/icons/TagFilled'
const theme = {
  appearances: {
    style: {
      type: 'variant',
      values: [ 'system', 'success', 'warning', 'error', 'subtle' ]
    },
    system: { type: 'state', values: [ true ] },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning', 'feature' ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { system: true },
      tokens: {
        borderLeftWidth: 0,
        borderRadius: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 8
      }
    },
    {
      if: { style: 'system' },
      tokens: {
        borderLeftWidth: 0,
        borderRadius: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 8
      }
    },
    {
      if: { style: 'subtle' },
      tokens: {
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderRadius: 6,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 8
      }
    },
    {
      if: { style: 'success' },
      tokens: {
        backgroundColor: '#f4f9f2',
        borderColor: '#2b8000',
        icon: PaletteIconStatusSuccess,
        iconColor: '#2b8000'
      }
    },
    {
      if: { validation: 'success' },
      tokens: {
        backgroundColor: '#f4f9f2',
        borderColor: '#2b8000',
        icon: PaletteIconStatusSuccess,
        iconColor: '#2b8000'
      }
    },
    {
      if: { style: 'warning' },
      tokens: {
        backgroundColor: '#fff9ee',
        borderColor: '#c77539',
        dismissIcon: null,
        icon: PaletteIconStatusWarning,
        iconColor: '#c77539'
      }
    },
    {
      if: { validation: 'warning' },
      tokens: {
        backgroundColor: '#fff9ee',
        borderColor: '#c77539',
        dismissIcon: null,
        icon: PaletteIconStatusWarning,
        iconColor: '#c77539'
      }
    },
    {
      if: { style: 'error' },
      tokens: {
        backgroundColor: '#fff6f8',
        borderColor: '#e12339',
        dismissIcon: null,
        icon: PaletteIconStatusError,
        iconColor: '#e12339'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        backgroundColor: '#fff6f8',
        borderColor: '#e12339',
        dismissIcon: null,
        icon: PaletteIconStatusError,
        iconColor: '#e12339'
      }
    },
    {
      if: { validation: 'feature' },
      tokens: {
        backgroundColor: '#4b286d',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#ffffff',
        dismissIcon: null,
        icon: PaletteIconTagFilled,
        iconColor: '#ffffff'
      }
    }
  ],
  tokens: {
    backgroundColor: '#efedff',
    borderBottomWidth: 1,
    borderColor: '#7c53a5',
    borderLeftWidth: 1,
    borderRadius: 6,
    borderRightWidth: 1,
    borderTopWidth: 1,
    color: '#414547',
    containerPaddingLeft: 0,
    containerPaddingRight: 0,
    dismissButtonGap: 24,
    dismissIcon: PaletteIconClose,
    dismissIconColor: '#676e73',
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    icon: PaletteIconStatusInfo,
    iconColor: '#4b286d',
    iconGap: 8,
    iconSize: 24,
    justifyContent: 'flex-start',
    lineHeight: 1.5,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12
  }
}
export default theme
